/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.0.0
 */
import bannerImage from './assets/images/banner/bitmap.png';
import bannerImage2x from './assets/images/banner/bitmap@2x.png';
import bannerImage3x from './assets/images/banner/bitmap@3x.png';
import bannerDefaultDesktop from './assets/images/default-banner-desktop.png';
import errorDeliveryImage from './assets/images/error/error-delivery.jpg';
import errorDeliveryImage2x from './assets/images/error/error-delivery@2x.jpg';
import errorDeliveryImage3x from './assets/images/error/error-delivery@3x.jpg';
import favicon from './assets/images/favicon.ico';
import loader from './assets/images/loader.gif';
import logoImage from './assets/images/logo.png';
import statusError from './assets/images/status/status-error.jpg';
import statusSuccess from './assets/images/status/status-success.jpg';

export {
    bannerImage,
    bannerImage2x,
    bannerImage3x,
    bannerDefaultDesktop,
    errorDeliveryImage,
    errorDeliveryImage2x,
    errorDeliveryImage3x,
    favicon,
    loader,
    logoImage,
    statusError,
    statusSuccess,
};
